import { useEffect, useState } from 'react'

import { useFetch } from '@marketplace-web/core-api/api-client-util'
import {
  getProfileUserInfo,
  transformProfileUserInfoResponse,
} from '@marketplace-web/profile/profile-data'

type Props = {
  userId: number
}

type ProfileUserInfo = {
  showSupportFunctionality: boolean
  canSendTemplates: boolean
  isShadowBanned: boolean | undefined
  isPermanentlyBanned: boolean | undefined
  isTemporarilyBanned: boolean | undefined
  isCompromised: boolean | undefined
  isListingRestricted: boolean | undefined
  isSellingRestricted: boolean | undefined
}

const useFetchProfileUserInfo = ({ userId }: Props) => {
  const [userInfo, setUserInfo] = useState<ProfileUserInfo>({
    showSupportFunctionality: false,
    canSendTemplates: false,
    isShadowBanned: undefined,
    isPermanentlyBanned: undefined,
    isTemporarilyBanned: undefined,
    isCompromised: undefined,
    isListingRestricted: undefined,
    isSellingRestricted: undefined,
  })

  const { fetch: fetchProfileUserInfo, transformedData: profileUserInfo } = useFetch(
    getProfileUserInfo,
    transformProfileUserInfoResponse,
  )

  useEffect(() => {
    fetchProfileUserInfo(userId)
  }, [fetchProfileUserInfo, userId])

  useEffect(() => {
    if (profileUserInfo) {
      setUserInfo({
        showSupportFunctionality: profileUserInfo.showSupportFunctionality,
        canSendTemplates: profileUserInfo.canSendTemplates,
        isShadowBanned: profileUserInfo.shadowBanned,
        isPermanentlyBanned: profileUserInfo.isPermanentlyBanned,
        isTemporarilyBanned: profileUserInfo.isTemporarilyBanned,
        isCompromised: profileUserInfo.isCompromised,
        isListingRestricted: profileUserInfo.isListingRestricted,
        isSellingRestricted: profileUserInfo.isSellingRestricted,
      })
    }
  }, [profileUserInfo])

  return {
    userInfo,
  }
}

export default useFetchProfileUserInfo
